import { useCallback, useEffect, useState } from "react";

type ToggleHandler = (isOpen: boolean, isOutsideClick?: boolean) => void;

const useToggleState = (defaultOpen: boolean, onToggle?: ToggleHandler): [boolean, ToggleHandler] => {
    const [isOpen, setIsOpen] = useState(defaultOpen);

    const handleToggle = useCallback(
        (isOpen: boolean, isOutsideClick = false) => {
            setIsOpen(isOpen);

            onToggle?.(isOpen, isOutsideClick);
        },
        [onToggle],
    );

    useEffect(() => {
        if (defaultOpen) {
            onToggle?.(true, false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return [isOpen, handleToggle];
};

export default useToggleState;
